// extracted by mini-css-extract-plugin
export default {"Cofounders":"Cofounders_Cofounders__RW8gk","TheFounder":"Cofounders_TheFounder__1MVfN"};